<template>
  <v-card
    class="px-0"
    flat
  >
    <v-card-text
      class="px-0"
      style="min-height: 55vh"
    >
      <v-row>
        <v-col
          cols="12"
          md="6"
          lg="4"
        >
          <v-row class="justify-start align-center">
            <v-col
              cols="12"
            >
              <v-text-field
                id="helper_note"
                v-model="helper.note"
                label="Notes"
                outlined
                dense
                hint="Entered text will be displayed above bottom bar in orders page."
                persistent-hint
              />
            </v-col>
            <v-col
              cols="12"
            >
              <v-text-field
                id="helper_detailed_description"
                v-model="helper.termsLabel"
                label="Terms and Conditions Label"
                two-line
                outlined
                hide-details
                dense
              />
            </v-col>
            <v-col
              cols="12"
            >
              <v-textarea
                id="helper_detailed_description"
                v-model="helper.detailedTermsLabel"
                label="Detailed Terms and Conditions"
                two-line
                outlined
                hide-details
                dense
                class="mt-0"
              />
            </v-col>
            <v-col
              cols="12"
            >
              <v-text-field
                id="helper_about_label"
                v-model="helper.aboutLabel"
                label="About Label"
                outlined
                hide-details
                dense
              />
            </v-col>
            <v-col
              cols="12"
            >
              <v-textarea
                id="about_us"
                v-model="helper.aboutUs"
                label="About Us"
                two-line
                outlined
                hide-details
                dense
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          lg="4"
          md="6"
        >
          <v-row class="justify-start align-center">
            <v-col
              cols="12"
            >
              <v-textarea
                id="helper_privacy_policy"
                v-model="helper.privacyPolicy"
                label="Privacy and Policy"
                two-line
                outlined
                hide-details
                dense
                class="mt-0"
              />
            </v-col>
            <v-col
              cols="12"
            >
              <v-textarea
                id="helper_refunds_and_cancellation"
                v-model="helper.refundsAndCancellations"
                label="Refunds and Cancellations"
                two-line
                outlined
                hide-details
                dense
                class="mt-0"
              />
            </v-col>
            <v-col
              cols="12"
            >
              <v-textarea
                id="hepler_contact_us"
                v-model="helper.contactUs"
                label="Contact us"
                two-line
                outlined
                hide-details
                dense
                class="mt-0"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-if="themeInfo.settings.isServiceChargeEditable"
          cols="12"
          lg="4"
          md="6"
        >
          <v-row>
            <v-col>
              <v-text-field
                id="helper_service_charge_label"
                v-model="helper.applyServiceChargeLabel"
                label="Apply Service Charge Label"
                outlined
                dense
                persistent-hint
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-textarea
                id="helper_service_charge_content"
                v-model="helper.applyServiceChargeContent"
                label="Apply Service Charge Content"
                two-line
                outlined
                hide-details
                dense
                class="mt-0"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="pa-3">
      <v-spacer />
      <v-btn
        color="error"
        @click="close()"
      >
        Close
      </v-btn>
      <v-btn
        color="success"
        @click="save()"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: "ContactlessSettings",
  props: {
     id: {
      type: Number || null,
      default: null
    },
    themeInfo: {
      type: Object,
      required: true
    }
  },
  data(){
    return {
      accountId: parseInt(this.$route.params.accountId),
      field: "helpers",
      displayModes: [
        { id: 1, label: "Default" },
        { id: 2, label: "Info Button" }
      ],
      enableTerms : false,
       helper : { note : "", terms: {show: false, displayMode: 1}}
    };
  },
  watch:{
    themeInfo:{
      handler(){
      this.init();
      },
      immediate:true
    }
  },
  //  created() {
  //   console.log("Created!!IN HELPERS");
    
  //   this.init();
  // },
   methods:{
    init(){ 
      if (this.themeInfo && this.themeInfo.helper) {
        this.helper = this.themeInfo.helper; 
      }else{
        this.helper={};
      }
    },
    save() {
        let url = `${this.ADMIN_API_URL}/accounts/${this.accountId}/contactless`;
        let formIns = this.themeInfo;
        formIns.helper = this.helper;
        let q;
        if (this.id) {
            q = this.$http.put(`${url}/${this.id}`, formIns);
        } else {
            q = this.$http.post(`${url}`, formIns);
        }
        q.then(
            (res) => {
            this.$store.commit("showSnackbar", {
                timeout: 3000,
                message: res.body.message
            });
            this.close();
            },
            (failure) => {
            this.handleFailure(failure);
            }
        );
    },
    close(){
      this.$emit("close");
    }

  }
};
</script>

<style lang="scss">
.note-elem {
  margin-top: 10px;
  font-size: 14px;
  color: black;
}
</style>